import React from 'react';

interface AuthorBlockProps {
  data: any;
}

export const AuthorBlock: React.FC<AuthorBlockProps> = (props) => {
  return <div>author{JSON.stringify(props, undefined, 2)}</div>;
};
